<div class="page-container unified">
  <div class="page-not-found-content-container">
    <div class="page-not-found-decoration-container col-12 col-md-6 col-lg-7">
      <div class="content">
        <img
          alt="RightBridge logo"
          id="Polygon-1"
          src="{{ './assets/rightbridge-logo.png' }}"
          class="unified-logo"
        />
        <mat-icon
          id="Polygon-2"
          class="app-button-icon"
          svgIcon="aw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-3"
          class="app-button-icon"
          svgIcon="pp_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-4"
          class="app-button-icon"
          svgIcon="iw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-5"
          class="app-button-icon"
          svgIcon="lw_icon"
        ></mat-icon>
        <mat-icon
          id="Polygon-6"
          class="app-button-icon"
          svgIcon="cm_icon"
        ></mat-icon>

        <app-background-decoration></app-background-decoration>
      </div>
    </div>

    <div class="display-content col-6">
      <h1>404 - Page Not Found</h1>
      <h3
        >The page you were looking for either doesn't exist or has been moved
        somewhere else.</h3
      >
      <div>
        <button
          mat-raised-button
          color="primary"
          (click)="notFoundNavigation('home')"
          ><mat-icon>home</mat-icon>Home</button
        >
        <button
          mat-raised-button
          color="primary"
          (click)="notFoundNavigation('back')"
          ><mat-icon>arrow_back</mat-icon>Go back</button
        >
      </div>
    </div>
  </div>
</div>
